import styled from "styled-components";

export const SCLink = styled.a`
  &,
  &:active,
  &:hover {
    text-decoration: none;
  }
`;
